export const PAGE_WALKER_ZHCHT = {
    next: 'ä¸ä¸æ­¥',
    prev: 'ä¸ä¸æ­¥',
    skip: 'è·³é',
    startNow: 'ç«å³é«é©'
};
